import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import {
  useOutsourceCategoriesQuery,
  useUpdateOutsourceCategory,
} from "../api/queries";
import { OutsourceCategoryTable } from "../ui/OutsourceCategoryTable";

export function OutsourceCategoriesPage() {
  const nav = useNavigate({
    from: "/app/performance/settings/outsource-categories",
  });
  const list = useOutsourceCategoriesQuery();
  const canUpdate = useActionPermission(["performance-events:update"]);
  const updateCategory = useUpdateOutsourceCategory();
  const [togglingId, setTogglingId] = useState<string | null>(null);

  const rows = [...(list.data?.data ?? [])].sort(
    (a, b) => a.sortOrder - b.sortOrder || a.nameLo.localeCompare(b.nameLo),
  );

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "Outsource", to: "/app/performance/outsources" },
            { label: "ຫມວດ Outsource" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">ຫມວດ Outsource</h2>
          <p className="text-muted-foreground">
            KOL / media / vendor categories — ເປີດ/ປິດໃຊ້ໃນຟອມ Event ແລະ master
          </p>
        </div>

        <div className="rounded-xl border bg-card pt-2">
          <OutsourceCategoryTable
            data={rows}
            isLoading={list.isLoading}
            canUpdate={!!canUpdate}
            togglingId={togglingId}
            onToggleActive={async (row) => {
              setTogglingId(row.id);
              try {
                await updateCategory.mutateAsync({
                  id: row.id,
                  input: { isActive: !row.isActive },
                });
              } finally {
                setTogglingId(null);
              }
            }}
          />
        </div>

        <div className="mt-4">
          <button
            type="button"
            className="text-primary text-sm underline-offset-4 hover:underline"
            onClick={() => nav({ to: "/app/performance/outsources" })}
          >
            ← ກັບໄປ Outsource master
          </button>
        </div>
      </Main>
    </>
  );
}
